module.exports = __webpack_public_path__ + "img/megamillions_bg.f503314c.png";